import { memo } from 'react';
import CollapsibleContent from '../../../core/components/CollapsibleContent';
import VerticalLayout from '../../../core/components/layout/VerticalLayout';
import useTyreFilter from '../../hooks/useTyreFilter';
import MatchcodeFilter from '../MatchCodeFilter';
import CollapsibleSideBarFilterTitle from '../ProductList/Filters/CollapsibleSideBarFilterTitle';
import useCurrentCategoryFilters from '../../queries/useCurrentCategoryFilters';
import type { CategoryFilterWithValues } from '../../types';
import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import styles from './FilterTyre.module.scss';

const FilterTyre = withErrorBoundary(
    memo(
        ({
            name,
            defaultExpand = true,
        }: {
            name: string;
            defaultExpand?: boolean;
        }) => {
            const { category } = useCurrentCategoryFilters({
                includeValues: true,
            });
            const filters = category.filters as CategoryFilterWithValues[];

            const { currentValues, updateFilters } = useTyreFilter(filters);

            return (
                <CollapsibleContent
                    expanded={defaultExpand}
                    title={
                        <CollapsibleSideBarFilterTitle>
                            {name}
                        </CollapsibleSideBarFilterTitle>
                    }
                    endArrow
                    filterIcon
                >
                    <div className={styles.values}>
                        <VerticalLayout stretchChildren>
                            <div className={styles.labeledFilter}>
                                <MatchcodeFilter
                                    onChange={value =>
                                        updateFilters({
                                            PIM_ATT_MATCHCODE: value,
                                        })
                                    }
                                    value={currentValues.PIM_ATT_MATCHCODE}
                                />
                            </div>
                        </VerticalLayout>
                    </div>
                </CollapsibleContent>
            );
        }
    )
);

export default withErrorBoundary(FilterTyre, { errorComponent: () => null });
